module.exports = {"371003001":"龙山路街道","371003002":"天福路街道","371003003":"环山路街道","371003100":"文登营镇","371003101":"大水泊镇","371003102":"张家产镇","371003103":"高村镇","371003104":"泽库镇","371003105":"侯家镇","371003106":"宋村镇","371003107":"泽头镇","371003108":"小观镇","371003109":"葛家镇","371003110":"米山镇","371003111":"界石镇","371003400":"开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/371003.json
// module id = 1562
// module chunks = 0